<template lang="pug">
  v-text-field(
    :value="value",
    :rules="required ? [v => !!v || this.$attrs.label + ' is required'] : []",
    type="number",
    v-bind="$attrs",
    @input="$emit('update:value', $event)",
  )
</template>

<script>
export default {
  props: {
    value: {
      validator: prop =>
        ['string', 'number', 'object', 'undefined'].includes(typeof prop),
      required: true,
    },

    required: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
